import React, { useState } from 'react';

import { IconChevronRight, IconChevronLeft } from '@tabler/icons';
import { Container, Items, Image, IconWrapper } from './styles';

import propertyImg from '../../assets/images/image-example.png';

interface IImageCarousel {
  data: any[];
}

const ImageCarousel: React.FC<IImageCarousel> = ({ data, ...rest }) => {
  const [transform, setTransform] = useState(0);

  const handleNext = () => {
    const currentPage = transform / -100 + 1;

    if (currentPage < data.length) {
      setTransform(transform - 100);
    } else {
      setTransform(0);
    }
  };

  const handlePrevious = () => {
    const currentPage = transform / -100 + 1;

    if (currentPage !== 1) {
      setTransform(transform + 100);
    } else {
      setTransform((data.length - 1) * -100);
    }
  };

  return (
    <Container {...rest}>
      <Items>
        {data?.length > 0 ? (
          data.map((image: any) => (
            <Image
              key={image.image_url}
              src={image.image_url}
              style={{ transform: `translateX(${transform}%)` }}
            />
          ))
        ) : (
          <Image src={propertyImg} />
        )}
      </Items>

      {data.length > 1 && (
        <>
          <IconWrapper onClick={handlePrevious} style={{ left: 0 }}>
            <IconChevronLeft size={30} color="#fff" />
          </IconWrapper>

          <IconWrapper onClick={handleNext} style={{ right: 0 }}>
            <IconChevronRight size={30} color="#fff" />
          </IconWrapper>
        </>
      )}
    </Container>
  );
};

export default ImageCarousel;
